export default {
    name: 'reportsPhysical',
    component: () => import(/* webpackChunkName: "reports-physical-Layout" */ '@/modules/reports/physical/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.reports.physical.index',
            component: () => import(/* webpackChunkName: "reports-physical-index" */ '@/modules/reports/physical/views/Index'),
        },
    ]
}